import React from 'react';
import DV    from 'ts-data-validator';

import Counter from '../../../../components/Counter/Counter';

const renderCounterBlock = function(data, index) {
  const {
          ANIMATION,
          BACKGROUND_COLOR,
          COLUMNS_COUNT,
          CONTENT,
        } = data;

  if (!DV.isArray(CONTENT) && !DV.isNotEmptyArray(CONTENT)) {
    return null;
  }

  return (
    <section
      key={index}
      className={'counter_wrapper'}
      style={{
        backgroundColor:      BACKGROUND_COLOR,
        '--original-columns': COLUMNS_COUNT,
      }}
    >
      <div className={'container'}>
        {CONTENT.map((item, index) => (
          <div key={index} className={'counter_item'}>
            <Counter amount={item?.COUNTER} animation={ANIMATION} prefix={item?.PREFIX} postfix={item?.POSTFIX} />
            <div
              className={'counter_description'}
              style={{ height: '100%' }}
              dangerouslySetInnerHTML={{ __html: item?.DESCRIPTION || '' }}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default renderCounterBlock;